import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const client = axios.create({ baseURL: API, timeout: 20000, withCredentials: true });

export const api = {
  // Public content
  articles: (params) => client.get("/articles", { params }).then((r) => r.data),
  article: (slug) => client.get(`/articles/${slug}`).then((r) => r.data),
  news: (params) => client.get("/news", { params }).then((r) => r.data),
  newsItem: (slug) => client.get(`/news/${slug}`).then((r) => r.data),
  interviews: (params) => client.get("/interviews", { params }).then((r) => r.data),
  interview: (slug) => client.get(`/interviews/${slug}`).then((r) => r.data),
  magazines: () => client.get("/magazines").then((r) => r.data),
  magazine: (slug) => client.get(`/magazines/${slug}`).then((r) => r.data),
  search: (q) => client.get("/search", { params: { q } }).then((r) => r.data),
  stats: () => client.get("/stats").then((r) => r.data),
  categories: () => client.get("/categories").then((r) => r.data),
  contact: (payload) => client.post("/contact", payload).then((r) => r.data),
  newsletter: (email) => client.post("/newsletter", { email }).then((r) => r.data),
  getFeatured: (payload) => client.post("/get-featured", payload).then((r) => r.data),
  siteSettings: () => client.get("/site-settings").then((r) => r.data),

  // Auth
  login: (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),
  changePassword: (current_password, new_password) =>
    client.post("/auth/change-password", { current_password, new_password }).then((r) => r.data),

  // Admin — content CRUD
  adminList: (kind) => client.get(`/admin/${kind}`).then((r) => r.data),
  adminGet: (kind, id) => client.get(`/admin/${kind}/${id}`).then((r) => r.data),
  adminCreate: (kind, payload) => client.post(`/admin/${kind}`, payload).then((r) => r.data),
  adminUpdate: (kind, id, payload) => client.put(`/admin/${kind}/${id}`, payload).then((r) => r.data),
  adminDelete: (kind, id) => client.delete(`/admin/${kind}/${id}`).then((r) => r.data),
  adminPublish: (kind, id) => client.post(`/admin/${kind}/${id}/publish`).then((r) => r.data),
  adminUnpublish: (kind, id) => client.post(`/admin/${kind}/${id}/unpublish`).then((r) => r.data),
  adminStats: () => client.get("/admin/stats").then((r) => r.data),
  adminMessages: (kind) => client.get(`/admin/messages/${kind}`).then((r) => r.data),
  adminUpdateSiteSettings: (payload) => client.put("/admin/site-settings", payload).then((r) => r.data),

  // Uploads
  upload: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
};

export default api;
